import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { ApiUrl } from '../constants/apiUrl';
import { CustomerTerminalDetail } from '../models/entities/customer-terminal-detail';
import { VCustomerTerminalDetail } from '../models/entities/v-customer-terminal-detail';
import { ListResponseModel } from '../models/responseModels/list-response-model';
import { ObjectResponseModel } from '../models/responseModels/object-response-model';
import { ResponseModel } from '../models/responseModels/response-model';

@Injectable({
  providedIn: 'root'
})
export class CustomerTerminalDetailService {

  constructor(private httpClient: HttpClient, private router: Router, private toastrService: ToastrService) { }

  getList(): Observable<ListResponseModel<VCustomerTerminalDetail>> {
    return this.httpClient.get<ListResponseModel<VCustomerTerminalDetail>>(ApiUrl.url + "CustomerTerminalDetail/getList");
  }

  getById(id: number): Observable<ObjectResponseModel<CustomerTerminalDetail>> {
    return this.httpClient.get<ObjectResponseModel<CustomerTerminalDetail>>(ApiUrl.url + "CustomerTerminalDetail/getById?Id=" + id);
  }

  getByTerminalId(terminalId: number){
    return this.httpClient.get<ObjectResponseModel<CustomerTerminalDetail>>(ApiUrl.url + "CustomerTerminalDetail/getByTerminalId?terminalId=" + terminalId);
  }

  getListByMainId(mainId: number): Observable<ListResponseModel<VCustomerTerminalDetail>> {
    return this.httpClient.get<ListResponseModel<VCustomerTerminalDetail>>(ApiUrl.url + "CustomerTerminalDetail/getListByMainId?mainId=" + mainId);
  }

  add(customerTerminalDetail: CustomerTerminalDetail) {
    return this.httpClient.post<ObjectResponseModel<CustomerTerminalDetail>>(ApiUrl.url + "CustomerTerminalDetail/add", customerTerminalDetail);
  }

  addRange(customerTerminalDetails: any) {
    return this.httpClient.post<ResponseModel>(ApiUrl.url + "CustomerTerminalDetail/addRange", customerTerminalDetails);
  }

  update(customerTerminalDetail: CustomerTerminalDetail) {
    return this.httpClient.post<ObjectResponseModel<CustomerTerminalDetail>>(ApiUrl.url + "CustomerTerminalDetail/update", customerTerminalDetail);
  }


  delete(id: number) {
    return this.httpClient.post<ResponseModel>(ApiUrl.url + "CustomerTerminalDetail/delete?Id=" + id, "");
  }

  deleteByMainId(mainId: number) {
    return this.httpClient.post<ResponseModel>(ApiUrl.url + "CustomerTerminalDetail/deleteByMainId?mainId=" + mainId, "");
  }

}
